import React from 'react'

interface TestimonialCardProps {
  quote: string
  author: string
  role: string
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({ quote, author, role }) => (
  <div className='bg-surface border border-black/[0.06] rounded-[14px] p-5 md:p-8 text-left'>
    <div className='text-pop text-[14px] tracking-[2px] mb-4'>★★★★★</div>
    <blockquote className='text-[15px] text-ink2 leading-[1.65] italic mb-5'>
      &ldquo;{quote}&rdquo;
    </blockquote>
    <div className='text-[13px] font-semibold text-ink'>{author}</div>
    <div className='text-[12px] text-ink3'>{role}</div>
  </div>
)

const Testimonials: React.FC = () => {
  return (
    <section className='py-[5.5rem] scroll-mt-20 px-4 md:px-10 border-b border-black/[0.06]' id='reviews'>
      <div className='max-w-[1060px] mx-auto text-center'>
        <div className='text-[12px] font-bold tracking-[2px] uppercase text-pop mb-3'>
          What people say
        </div>
        <h2 className='font-hd text-[28px] md:text-[42px] font-extrabold tracking-[-1.5px] md:tracking-[-2px] leading-[1.08]'>
          Don&rsquo;t take our word for it.
        </h2>
        <div className='grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 mt-12'>
          <TestimonialCard
            quote='We came in with a vague idea and left with a product our customers pay for every month. These guys just get it.'
            author='Sarah M.'
            role='Founder, Series A startup'
          />
          <TestimonialCard
            quote="First agency that actually hit the deadline. No drama, no surprises, just shipped software. We've re-engaged them three times."
            author='David R.'
            role='VP of Operations'
          />
          <TestimonialCard
            quote="Having a technical partner who explains things in plain English changed everything. We finally understand what we're paying for."
            author='Michelle T.'
            role='CEO, Healthcare company'
          />
        </div>
      </div>
    </section>
  )
}

export default Testimonials
